import { TOO_MANY_REQUESTS_ERROR_TYPE } from '../constansts/index.js';
import { normalizeRussianCountryCode, normalizePhone } from './phone.js';
import { convertDateDiffToMilliseconds } from './time.js';

const getWindowLocation = () => typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}` : '';
const joinRetryAfterAndErrorType = (retryAfter) => {
    const timeToRetry = convertDateDiffToMilliseconds(retryAfter);
    return `${TOO_MANY_REQUESTS_ERROR_TYPE}|${timeToRetry}`;
};
const splitRetryAfterAndErrorType = (type) => {
    const [errorType, timeToRetry] = type.split('|');
    if (!timeToRetry)
        return ['', 0];
    return [errorType, parseInt(timeToRetry, 10)];
};
const convertDefaultValues = (defaultValues) => {
    if (typeof defaultValues === 'function')
        return defaultValues;
    const DEFAULT_VALUES = {
        ["agreement" /* FIELD_NAME.AGREEMENT */]: true,
    };
    if (typeof defaultValues === 'undefined')
        return DEFAULT_VALUES;
    const { ["phone" /* FIELD_NAME.PHONE */]: phone, ...rest } = defaultValues;
    return {
        ...DEFAULT_VALUES,
        ...rest,
        ...(phone ? { ["phone" /* FIELD_NAME.PHONE */]: normalizeRussianCountryCode(normalizePhone(phone)) } : {}),
    };
};

export { convertDefaultValues, getWindowLocation, joinRetryAfterAndErrorType, splitRetryAfterAndErrorType };
//# sourceMappingURL=utils.js.map
